import { lazy, Suspense } from "react";
import { Loader } from "@/components";
import TableFiltersContextProvider from "@/common/contexts/Table.context";
import { checkAuth, guardCheck } from "@/common/utils";
import { redirect } from "react-router";

const Dashboard = lazy(() => import("@/pages/Dashboard.page"));
const DashboardMe = lazy(() => import("@/pages/DashboardMe.page"));

const dashboardRoute = [
  {
    path: "/",
    loader: async ({ request }: { request: Request }) => {
      checkAuth();
      const isAllowed = guardCheck(request, "dashboard/airx");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <Suspense fallback={<Loader />}>
        <TableFiltersContextProvider>
          <Dashboard />
        </TableFiltersContextProvider>
      </Suspense>
    ),
  },
  {
    path: "/me",
    loader: async ({ request }: { request: Request }) => {
      checkAuth();
      const isAllowed = guardCheck(request, "dashboard/customer/vendor");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <Suspense fallback={<Loader />}>
        <TableFiltersContextProvider>
          <DashboardMe />
        </TableFiltersContextProvider>
      </Suspense>
    ),
  },
];
export default dashboardRoute;
